import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AlertType = 'info' | 'warning' | 'danger';
export type IconPlacement = 'left' | 'right';

@Component({
  selector: 'app-alert-message',
  imports: [CommonModule],
  templateUrl: './alert-message.component.html',
})
export class AlertMessageComponent {
  @Input() type: AlertType = 'info';
  @Input() message: string = '';
  @Input() icon: string = '';
  @Input() iconTooltip: string = '';
  @Input() iconPlacement: IconPlacement = 'left';

  get alertClasses(): string {
    const baseClasses = 'w-full mt-4 flex items-center gap-2 p-3 rounded-xl';

    switch (this.type) {
      case 'info':
        return `${baseClasses} bg-blue-50 text-blue-700`;
      case 'warning':
        return `${baseClasses} bg-yellow-50 text-yellow-700`;
      case 'danger':
        return `${baseClasses} bg-red-50 text-red-500`;
      default:
        return baseClasses;
    }
  }

  get defaultIcon(): string {
    switch (this.type) {
      case 'info':
        return 'ph ph-info';
      case 'warning':
        return 'ph ph-warning-circle';
      case 'danger':
        return 'ph ph-warning-circle';
      default:
        return 'ph ph-info';
    }
  }
}
